import Payments from "./Payments";
import AppTabs from '../../components/AppTabs';
import Billing from "./Billing";
import { useTranslations } from "../../store/translations/hooks";
import React from "react";
import { TK } from "../../store/translations/translationKeys";
import { Tabs, Tab } from "@material-ui/core";
import TitledContainer from "../../components/TitledContainer";
import Expenses from "./Expenses";
import InVsOut from "./InVsOut";
import Invoices from "./Invoices";
import { DebtTab } from "./DebtTab";
import SystemPayments from "./SystemPayments";
import { useHistory, useLocation } from "react-router-dom";
import { FeatureEnum } from "../../models";
import { getFeatures, canManagePrices, getLoggedUserCompanies } from "../../store/session/selectors";
import { useSelector } from "react-redux";

const APPOINTMINT_TENANT_ID = '1760715743';

type BillingTab = 'global' | 'income' | 'outcome' | 'appointments' | 'invoices' | 'debt' | 'commissions';

export default () => {
    const t = useTranslations()
    const history = useHistory()
    const location = useLocation()

    const queryParams = new URLSearchParams(location.search)
    const tabFromUrl = queryParams.get('tab') as BillingTab | null
    const validTabs: BillingTab[] = ['global', 'income', 'outcome', 'appointments', 'invoices', 'debt', 'commissions']

    const features = useSelector(getFeatures);
    const hasPriviledgedAccess = useSelector(canManagePrices);
    const companies = useSelector(getLoggedUserCompanies);
    const isAppointmintTenant = companies[0] === APPOINTMINT_TENANT_ID;

    const defaultTab: BillingTab = hasPriviledgedAccess ? 'global' : 'invoices'
    const tab: BillingTab = tabFromUrl && validTabs.includes(tabFromUrl) ? tabFromUrl : defaultTab

    const setTab = (newTab: BillingTab) => {
        const params = new URLSearchParams(location.search)
        params.set('tab', newTab)
        history.push({ search: params.toString() })
    }
    return (
        <TitledContainer id='billing' title={t(TK.billing)}>
            <AppTabs value={tab} onChange={(_, v) => setTab(v)} indicatorColor="primary" textColor="primary" style={{ borderBottom: 'var(--border-thin) solid var(--appLigthGrey)' }}>
                {hasPriviledgedAccess && <Tab label={t(TK.global)} value="global" />}
                {hasPriviledgedAccess && <Tab label={t(TK.income)} value="income" />}
                <Tab label={t(TK.outcome)} value="outcome" />
                {hasPriviledgedAccess && <Tab label={t(TK.appointments)} value="appointments" />}
                <Tab label={t(TK.inDebt)} value="debt" />
                {features.includes(FeatureEnum.Invoices) && <Tab label={t(TK.invoices)} value="invoices" />}
                {isAppointmintTenant && <Tab label={t(TK.commissions)} value="commissions" />}
            </AppTabs>
            <div className='adminTabsContent'>
                {tab === 'global' && <InVsOut/>}
                {tab === 'income' && <Payments/>}
                {tab === 'outcome' && <Expenses/>}
                {tab === 'appointments' && <Billing/>}
                {tab === 'debt' && <DebtTab/>}
                {tab === 'invoices' && <Invoices/>}
                {tab === 'commissions' && <SystemPayments/>}
            </div>
        </TitledContainer>
    )
}
